import React from 'react'

import { LntButton } from '@app/components/base'
import { PermissionWrapper } from '@app/components'

import { FILE_TYPES } from '@app/api/constants'
import { PERMISSION } from '@app/constants/permission'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { TopFilterProps } from './types'

export const TopMenu: React.FC<TopFilterProps> = ({
  openProductsFilter,
  openImportFromExcelModal,
  openRegistryTotalModal,
  onDownloadFromExcel
}) => {
  return (
    <div className={ styles.topMenu }>
      <PermissionWrapper
        key='registry-inner-download'
        requiredPermissions={ [PERMISSION.changeMonitoringList] }
      >
        <LntButton
          type={ BUTTON_TYPE.text }
          size={ SIZE.small }
          onClick={ () => onDownloadFromExcel(FILE_TYPES.xlsx) }
        >
          Скачать шаблон
        </LntButton>
      </PermissionWrapper>

      <PermissionWrapper requiredPermissions={ [PERMISSION.changeMonitoringList] }>
        <LntButton
          key='registry-inner-import-change'
          type={ BUTTON_TYPE.text }
          size={ SIZE.small }
          onClick={ openImportFromExcelModal }
        >
          Импорт из excel
        </LntButton>
      </PermissionWrapper>

      <PermissionWrapper requiredPermissions={ [PERMISSION.changeMonitoringList] }>
        <LntButton
          key='registry-inner-list-add'
          type={ BUTTON_TYPE.text }
          size={ SIZE.small }
          onClick={ openProductsFilter }
        >
          Добавить из справочника
        </LntButton>
      </PermissionWrapper>

      <PermissionWrapper requiredPermissions={ [PERMISSION.viewMonitoringListsRegistry] }>
        <LntButton
          key='registry-inner-total-modal'
          type={ BUTTON_TYPE.text }
          size={ SIZE.small }
          onClick={ openRegistryTotalModal }
        >
          Итого по списку
        </LntButton>
      </PermissionWrapper>
    </div>
  )
}
